import { useState, useEffect } from 'react';
import strapiAPI from '../api/strapi';
import { getStrapiData } from '../utils/helpers';
import { STRAPI_URL } from '../config/constants';

// export const useFetch = (collection, params = '?populate=*') => {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 setLoading(true);
//                 const response = await strapiAPI.getAll(collection, params);
//                 const extractedData = getStrapiData(response);
//                 setData(extractedData);
//                 setError(null);
//             } catch (err) {
//                 setError(err.message);
//                 setData(null);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [collection, params]);

//     return { data, loading, error };
// };

export const useFetch = (collection, params = '?populate=*') => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [meta, setMeta] = useState(null); // Add this line

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await strapiAPI.getAll(collection, params);
                const extractedData = getStrapiData(response);
                setData(extractedData);
                setMeta(response.meta); // Add this line to store metadata
                setError(null);
            } catch (err) {
                setError(err.message);
                setData(null);
                setMeta(null); // Add this line
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [collection, params]);

    return { data, loading, error, meta }; // Return meta as well
};




// export const useFetchOne = (collection, id, params = '?populate=*') => {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         if (!id) return;

//         const fetchData = async () => {
//             try {
//                 setLoading(true);
//                 const response = await strapiAPI.getOne(collection, id, params);
//                 const extractedData = getStrapiData(response);
//                 setData(extractedData);
//                 setError(null);
//             } catch (err) {
//                 setError(err.message);
//                 setData(null);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [collection, id, params]);

//     return { data, loading, error };
// };



export const useFetchOne = (collection, slug, params = 'populate=*') => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!slug) return;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await strapiAPI.getOneBySlug(collection, slug, params);
                const extractedData = getStrapiData(response);
                setData(extractedData);
                setError(null);
            } catch (err) {
                setError(err.message);
                setData(null);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [collection, slug, params]);

    return { data, loading, error };
};



// export const useFetchOne = (endpoint, slug, populate = '?populate=*') => {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 setLoading(true);
//                 setError(null);

//                 // Use slug filter instead of direct ID endpoint
//                 const populateQuery = populate ? `&${populate}` : '';
//                 const url = `${STRAPI_URL}/api/${endpoint}?filters[slug][$eq]=${slug}${populateQuery}`;

//                 const response = await fetch(url);

//                 if (!response.ok) {
//                     throw new Error(`HTTP error! status: ${response.status}`);
//                 }

//                 const result = await response.json();

//                 // Since filtering returns an array, get the first item
//                 if (result.data && result.data.length > 0) {
//                     setData(result.data[0]);
//                 } else {
//                     setData(null);
//                 }
//             } catch (err) {
//                 setError(err.message);
//                 setData(null);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         if (slug) {
//             fetchData();
//         }
//     }, [endpoint, slug, populate]);

//     return { data, loading, error };
// };